import { render, staticRenderFns } from "./RankingIndex.vue?vue&type=template&id=685f7468&scoped=true"
import script from "./RankingIndex.vue?vue&type=script&lang=ts"
export * from "./RankingIndex.vue?vue&type=script&lang=ts"
import style0 from "./RankingIndex.vue?vue&type=style&index=0&id=685f7468&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "685f7468",
  null
  
)

export default component.exports